const { validateMatch } = require('./engine');
function database() {
  return new Promise((resolve,reject) => {
    const request = indexedDB.open('kelimoOfflineV222',1);
    request.onupgradeneeded = () => request.result.createObjectStore('data');
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(Error('Cihazda oyun kaydı açılamadı.'));
  });
}
async function transaction(mode, task) {
  const db = await database();
  return new Promise((resolve,reject) => {
    const tx = db.transaction('data',mode), store = tx.objectStore('data');
    const request = task(store);
    tx.oncomplete = () => { const result = request?.result; db.close(); resolve(result); };
    tx.onerror = tx.onabort = () => { db.close(); reject(Error('Oyun kaydedilemedi. Cihaz depolamasını kontrol et.')); };
  });
}
const read = key => transaction('readonly',store => store.get(key));
const write = (key,value) => transaction('readwrite',store => store.put(value,key));
const ownerKey = username => String(username || 'guest').toLowerCase();
async function localRecords(username) {
  const owner=ownerKey(username),prefix=`local-match:${owner}:`,db=await database();
  return new Promise((resolve,reject)=>{
    const tx=db.transaction('data','readonly'),values=[];
    const request=tx.objectStore('data').openCursor(IDBKeyRange.bound(prefix,prefix+'\uffff'));
    request.onsuccess=()=>{const cursor=request.result;if(cursor){if(validateMatch(cursor.value)&&cursor.value.owner===owner)values.push(cursor.value);cursor.continue();}};
    tx.oncomplete=()=>{db.close();resolve(values.sort((a,b)=>b.startedAt-a.startedAt));};
    tx.onerror=()=>{db.close();reject(Error('Oyun listesi okunamadı.'));};
  });
}
async function saveLocalMatch(state,{activate=true}={}) {
  if(!validateMatch(state)||!state.owner||state.clockSpec?.version!==2)throw Error('Oyun kaydı geçersiz.');
  return transaction('readwrite',store=>{store.put(state,`local-match:${state.owner}:${state.id}`);if(activate)store.put(state.id,`local-active:${state.owner}`);});
}
async function loadLocalMatch(username,id) {
  const owner=ownerKey(username), key=id||await read(`local-active:${owner}`);
  const state=key?await read(`local-match:${owner}:${key}`):null;
  return validateMatch(state)&&state.owner===owner&&state.clockSpec?.version===2?state:null;
}
async function loadMatch() { const state = await read('active'); return validateMatch(state) ? state : null; }
async function saveMatch(state) {
  if (!validateMatch(state)) throw Error('Oyun kaydı geçersiz.');
  // Active pointer and completed history are atomic in a single transaction.
  return transaction('readwrite',store => {
    store.put(state,'active');
    if (state.status !== 'playing') store.put(state,`match:${state.id}`);
  });
}
async function history() { const entries = await transaction('readonly',store => store.getAll()); return entries.filter(value => validateMatch(value) && value.status !== 'playing').filter((value,index,list) => list.findIndex(other => other.id === value.id) === index).sort((a,b) => b.startedAt-a.startedAt).slice(0,20); }
function validDictionary(value) { return Number.isSafeInteger(value?.version) && value.version > 0 && Array.isArray(value.words) && value.words.length > 0 && value.words.length < 300000 && value.words.every(word => typeof word === 'string' && word.length >= 2 && word.length <= 10 && /^[abcçdefgğhıijklmnoöprsştuüvyz]+$/iu.test(word)); }
function completeDictionary(value) {
 if(!validDictionary(value)||!value.meanings?.entries)return false;
 const {hasMeaning}=require('../utils/meaningAdmission');
 return value.words.every(word=>hasMeaning(value.meanings.entries[word]));
}
async function prepareDictionary(url, fetcher = fetch) {
  const cached = await read('dictionary');
  if (navigator.onLine === false && completeDictionary(cached)) return cached;
  const controller = new AbortController(); let timer;
  try {
    const timeout = new Promise((_,reject) => { timer = setTimeout(() => {controller.abort();reject(Error('Sözlük indirme zaman aşımı.'));},90000); });
    const response = await Promise.race([fetcher(url,{cache:'no-store',signal:controller.signal}),timeout]);
    if (!response.ok) throw Error('Sözlük indirilemedi.');
    const value = await Promise.race([response.json(),timeout]);
    if (!completeDictionary(value)) throw Error('Sözlük ve anlam paketi eşleşmiyor.');
    if(value.meanings){const {hasMeaning}=require('../utils/meaningAdmission');if(!value.meanings.entries||value.words.some(word=>!hasMeaning(value.meanings.entries[word])))throw Error('Sözlük ve anlam paketi eşleşmiyor.');}
    await write(`dictionary:${value.version}`,value); await write('dictionary',value); return value;
  } catch (error) { if (completeDictionary(cached)) return cached; throw Error('İlk kullanım için internete bağlanıp sözlüğü bir kez indirmen gerekiyor.'); }
  finally { clearTimeout(timer); }
}
module.exports = {read,write,loadMatch,saveMatch,history,prepareDictionary,validDictionary,completeDictionary,localRecords,saveLocalMatch,loadLocalMatch};
